/*  Copyright (c) 2023 */

import { Actions, ofType, createEffect } from '@ngrx/effects';
import { NAMESPACE, ConveyorAdminActions } from '../conveyor-admin.reducer';
import { switchMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';
import { of } from 'rxjs';

@Injectable()
export class ConveyorAdminEffects {

  constructor(private action$: Actions, private localStorage: LocalStorageService) { }

  init$ = createEffect(() =>
    this.action$.pipe(
      ofType(ConveyorAdminActions.INIT),
      switchMap(() => {
        const local = this.localStorage.get(`${NAMESPACE}`) as any;
        if (local) {
          return of({ type: ConveyorAdminActions.SET_CONFIGURATION, payload: local });
        } else {
          return of({ type: ConveyorAdminActions.KEEP_CURRENT_STATE });
        }
      })
    )
  );

  saveOnLs$ = createEffect(() =>
    this.action$.pipe(
      ofType(ConveyorAdminActions.SET_CONFIGURATION),
      tap((action: any) => {
        this.localStorage.set(`${NAMESPACE}`, action.payload);
      })
    ), { dispatch: false }
  );

  saveLastState$ = createEffect(() =>
    this.action$.pipe(
      ofType(ConveyorAdminActions.SET_LAST_STATE),
      tap((action: any) => {
        this.localStorage.set(`${NAMESPACE}`, action.payload);
      })
    ), { dispatch: false }
  );
}
